import { ReactNode } from "react";

interface Props {
  children?: ReactNode;
}

export function H3Text({ children }: Props) {
  return <span className="contents text-xl font-thin">{children}</span>;
}
